// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d135b77b","title":"d3fb903f","forms":"f6a21b4b","formsShow":"ff3ebeaf"};